<mat-calendar [(selected)]="selectedDate"  (selectedChange)="onDateChanged($event)"
              [dateClass]="highlightDates()"
              [dateFilter]="dateFilter" #calendar>
</mat-calendar>
<ng-content></ng-content>

